export default {
  accounts: {
    "1100": "เงินสดและรายการเทียบเท่าเงินสด",
    "1110": "เงินสดในมือ",
    "1120": "เงินฝากธนาคาร",
    "1130": "พักเงิน Stripe",
    "1200": "ลูกหนี้การค้า",
    "1210": "ลูกหนี้ค่าเช่า",
    "1220": "ลูกหนี้ค่าสาธารณูปโภค",
    "1300": "ค่าใช้จ่ายจ่ายล่วงหน้า",
    "1400": "เงินมัดจำจ่าย",
    "1500": "ที่ดินอาคารและอุปกรณ์",
    "1510": "อาคาร",
    "1520": "เครื่องตกแต่งและติดตั้ง",
    "1530": "อุปกรณ์สำนักงาน",
    "1590": "ค่าเสื่อมราคาสะสม",
    "2100": "เจ้าหนี้การค้า",
    "2200": "ค่าใช้จ่ายค้างจ่าย",
    "2300": "เงินประกันรับ",
    "2350": "เงินรับล่วงหน้าจากลูกค้า",
    "2400": "รายได้ค่าเช่ารับล่วงหน้า",
    "2500": "ภาษีมูลค่าเพิ่มค้างจ่าย",
    "2600": "ภาษีหัก ณ ที่จ่ายค้างจ่าย",
    "3100": "ทุนเจ้าของ",
    "3200": "กำไรสะสม",
    "4100": "รายได้ค่าเช่า",
    "4200": "รายได้ค่าส่วนกลาง",
    "4300": "รายได้ค่าสาธารณูปโภค",
    "4310": "รายได้ค่าน้ำ",
    "4320": "รายได้ค่าไฟฟ้า",
    "4400": "รายได้ค่าจอดรถ",
    "4500": "รายได้ค่าปรับล่าช้า",
    "4600": "รายได้อื่น",
    "4650": "รายได้ค่าจอง",
    "4900": "ส่วนลดและโปรโมชั่นการขาย",
    "4950": "รายได้จากเงินประกันที่ริบและค่าเสียหาย",
    "5100": "ค่าบำรุงรักษาอาคาร",
    "5150": "ค่าธรรมเนียมการชำระเงิน",
    "5200": "ค่าสาธารณูปโภค",
    "5210": "ค่าน้ำประปา",
    "5220": "ค่าไฟฟ้า",
    "5300": "ค่าประกันภัย",
    "5400": "ค่าเสื่อมราคา",
    "5500": "เงินเดือนและค่าจ้าง",
    "5600": "ค่าใช้จ่ายในการบริหาร",
    "5700": "ค่าซ่อมแซมและบำรุงรักษา",
    "5800": "ค่าวัสดุสิ้นเปลือง",
    "5900": "ค่าใช้จ่ายอื่น",
  },

  title: 'บัญชี',

  chart_of_accounts: {
    title: 'ผังบัญชี',
    description: 'จัดการบัญชีแยกประเภททั่วไป',
    add_account: 'เพิ่มบัญชี',
    seed_accounts: 'สร้างผังบัญชีมาตรฐาน',
    seed_confirm: 'ระบบจะสร้างผังบัญชีมาตรฐาน บัญชีระบบที่มีอยู่จะไม่ถูกแก้ไข ดำเนินการต่อหรือไม่?',
    seed_success: 'สร้างผังบัญชีมาตรฐานเรียบร้อยแล้ว',
    delete_confirm: 'คุณแน่ใจหรือไม่ว่าต้องการลบบัญชีนี้?',
    delete_success: 'ลบบัญชีเรียบร้อยแล้ว',
    create_success: 'สร้างบัญชีเรียบร้อยแล้ว',
    update_success: 'อัปเดตบัญชีเรียบร้อยแล้ว',
    system_account: 'บัญชีระบบ',
    cannot_delete_system: 'ไม่สามารถลบบัญชีระบบได้',
    empty_title: 'ยังไม่มีบัญชี',
    empty_description: 'สร้างผังบัญชีมาตรฐานหรือสร้างบัญชีกำหนดเองเพื่อเริ่มต้น',
  },

  opening_balance: {
    title: 'ตั้งยอดยกมา',
    balance: 'ยอดคงเหลือ',
    as_of_date: 'ณ วันที่',
    bank_balance: 'ยอดเงินฝากธนาคาร: {{balance}}',
    description: 'ระบุยอดเงินฝากธนาคารที่มีอยู่ก่อนเริ่มบันทึกรายการใน FlowRent',
    status_error: 'ตรวจสอบยอดยกมาไม่สำเร็จ กรุณาลองใหม่',
    invalid_balance: 'กรุณาระบุยอดเงินที่ถูกต้อง',
    date_required: 'กรุณาระบุวันที่ของยอดยกมา',
  },

  errors: {
    opening_balance_already_exists: 'บัญชีนี้ตั้งยอดยกมาแล้ว',
    opening_balance_missing_gl_account: 'กรุณาตั้งบัญชีเงินฝากธนาคาร (1120) และส่วนของเจ้าของ (3100) ก่อนตั้งยอดยกมา',
    validation_error: 'กรุณาตรวจสอบยอดเงินและวันที่ แล้วลองอีกครั้ง',
    fields: {
      balance: 'ยอดเงิน',
      as_of_date: 'วันที่',
    },
    codes: {
      blank: 'จำเป็นต้องระบุ',
      invalid: 'ไม่ถูกต้อง',
      invalid_amount: 'ต้องมากกว่าศูนย์และมีทศนิยมไม่เกินสองตำแหน่ง',
      amount_too_large: 'ต้องไม่เกิน 9,999,999,999.99',
      invalid_date: 'ต้องเป็นวันที่ที่ถูกต้องตามปฏิทิน',
      not_a_number: 'ต้องเป็นตัวเลข',
      greater_than: 'ต้องมากกว่าศูนย์',
      greater_than_or_equal_to: 'ต้องเป็นศูนย์หรือมากกว่า',
    },
  },

  journal_entries: {
    title: 'รายการบันทึกบัญชี',
    description: 'บันทึกและจัดการรายการทางบัญชี',
    new_entry: 'รายการบันทึกใหม่',
    post_entry: 'ผ่านรายการ',
    void_entry: 'ยกเลิกรายการ',
    post_confirm: 'ผ่านรายการบันทึกบัญชีนี้? เมื่อผ่านแล้วจะไม่สามารถแก้ไขรายการย่อยได้',
    void_reason: 'เหตุผลการยกเลิก',
    void_reason_placeholder: 'ระบุเหตุผลในการยกเลิกรายการนี้...',
    void_confirm: 'ยกเลิกรายการบันทึกบัญชีนี้?',
    void_success: 'ยกเลิกรายการบันทึกบัญชีแล้ว',
    post_success: 'ผ่านรายการบันทึกบัญชีแล้ว',
    create_success: 'สร้างรายการบันทึกบัญชีแล้ว',
    update_success: 'อัปเดตรายการบันทึกบัญชีแล้ว',
    delete_confirm: 'ลบรายการบันทึกบัญชีฉบับร่างนี้?',
    delete_success: 'ลบรายการบันทึกบัญชีแล้ว',
    add_line: 'เพิ่มรายการ',
    remove_line: 'ลบ',
    balance_ok: 'สมดุล',
    balance_off: 'ไม่สมดุล',
    debit_total: 'รวมเดบิต',
    credit_total: 'รวมเครดิต',
    difference: 'ส่วนต่าง',
    draft_only_edit: 'แก้ไขได้เฉพาะรายการฉบับร่างเท่านั้น',
    empty_title: 'ยังไม่มีรายการบันทึกบัญชี',
    empty_description: 'สร้างรายการบันทึกบัญชีเพื่อบันทึกธุรกรรมทางการเงิน',
    // T139-002b
    not_found: 'ไม่พบรายการบันทึกบัญชี',
    back_to_journal_entries: 'กลับไปรายการบันทึกบัญชี',
    reference_types: {
      invoice: 'ใบแจ้งหนี้',
      payment: 'การชำระเงิน',
      expense: 'ค่าใช้จ่าย',
      stripe_payout: 'การจ่ายเงิน Stripe',
      late_fee_line: 'รายการค่าปรับล่าช้า',
    },
  },

  financial_statements: {
    title: 'งบการเงิน',
    description: 'ดูงบกำไรขาดทุน งบดุล และกระแสเงินสด',
    income_statement: 'งบกำไรขาดทุน',
    balance_sheet: 'งบดุล',
    cash_flow: 'งบกระแสเงินสด',
    export_csv: 'ส่งออก CSV',
    revenue: 'รายได้',
    expenses: 'ค่าใช้จ่าย',
    net_income: 'กำไรสุทธิ',
    assets: 'สินทรัพย์',
    liabilities: 'หนี้สิน',
    equity: 'ส่วนของผู้ถือหุ้น',
    total_assets: 'รวมสินทรัพย์',
    total_liabilities: 'รวมหนี้สิน',
    retained_earnings: 'กำไรสะสม',
    current_year_earnings: 'กำไรปีปัจจุบัน',
    total_equity: 'รวมส่วนของผู้ถือหุ้น',
    liabilities_and_equity: 'รวมหนี้สินและส่วนของผู้ถือหุ้น',
    operating_activities: 'กิจกรรมดำเนินงาน',
    investing_activities: 'กิจกรรมลงทุน',
    financing_activities: 'กิจกรรมจัดหาเงิน',
    net_change: 'เงินสดเพิ่ม/ลดสุทธิ',
    beginning_cash: 'เงินสดต้นงวด',
    ending_cash: 'เงินสดปลายงวด',
    as_of_date: 'ณ วันที่',
    start_date: 'วันที่เริ่มต้น',
    end_date: 'วันที่สิ้นสุด',
    total: 'รวม',
    subtotal: 'รวมย่อย',
    empty_title: 'ไม่มีข้อมูล',
    empty_description: 'เลือกช่วงวันที่เพื่อดูงบการเงิน',
  },

  fixed_assets: {
    title: 'ทะเบียนสินทรัพย์ถาวร',
    description: 'ติดตามและคิดค่าเสื่อมราคาสินทรัพย์ถาวร',
    new_asset: 'สินทรัพย์ถาวรใหม่',
    dispose_asset: 'จำหน่ายสินทรัพย์',
    dispose_confirm: 'จำหน่ายสินทรัพย์นี้? การดำเนินการนี้ไม่สามารถยกเลิกได้',
    dispose_date: 'วันที่จำหน่าย',
    dispose_amount: 'จำนวนเงินที่ขาย / จำหน่าย',
    dispose_success: 'จำหน่ายสินทรัพย์เรียบร้อยแล้ว',
    create_success: 'สร้างสินทรัพย์ถาวรเรียบร้อยแล้ว',
    update_success: 'อัปเดตสินทรัพย์ถาวรเรียบร้อยแล้ว',
    delete_confirm: 'ลบสินทรัพย์ถาวรนี้?',
    delete_success: 'ลบสินทรัพย์ถาวรเรียบร้อยแล้ว',
    empty_title: 'ยังไม่มีสินทรัพย์ถาวร',
    empty_description: 'ลงทะเบียนสินทรัพย์ถาวรเพื่อติดตามค่าเสื่อมราคาและมูลค่าตามบัญชี',
  },

  labels: {
    code: 'รหัสบัญชี',
    name: 'ชื่อบัญชี',
    name_th: 'ชื่อบัญชี (ไทย)',
    account_type: 'ประเภทบัญชี',
    normal_balance: 'ยอดปกติ',
    active: 'ใช้งาน',
    parent_account: 'บัญชีแม่',
    entry_number: 'เลขที่รายการ',
    entry_date: 'วันที่บันทึก',
    description: 'รายละเอียด',
    status: 'สถานะ',
    total_debit: 'รวมเดบิต',
    total_credit: 'รวมเครดิต',
    reference: 'อ้างอิง',
    property: 'อสังหาริมทรัพย์',
    account: 'บัญชี',
    debit: 'เดบิต',
    credit: 'เครดิต',
    acquisition_date: 'วันที่ซื้อ',
    acquisition_cost: 'ราคาทุน',
    salvage_value: 'มูลค่าซาก',
    useful_life: 'อายุการใช้งาน (เดือน)',
    depreciation_method: 'วิธีค่าเสื่อมราคา',
    accumulated_depreciation: 'ค่าเสื่อมราคาสะสม',
    net_book_value: 'มูลค่าตามบัญชีสุทธิ',
    gl_account: 'บัญชีแยกประเภท',
    depreciation_account: 'บัญชีค่าเสื่อมราคา',
    disposed_at: 'วันที่จำหน่าย',
    useful_life_months_count: '{{count}} เดือน',
  },

  placeholders: {
    code: 'เช่น 1000',
    name: 'เช่น Cash and Cash Equivalents',
    name_th: 'เช่น เงินสดและรายการเทียบเท่าเงินสด',
    description: 'กรอกรายละเอียด',
    search_account: 'ค้นหาบัญชี...',
    void_reason: 'ระบุเหตุผลในการยกเลิก...',
    asset_name: 'เช่น เครื่องปรับอากาศ',
  },

  account_types: {
    asset: 'สินทรัพย์',
    liability: 'หนี้สิน',
    equity: 'ส่วนของผู้ถือหุ้น',
    revenue: 'รายได้',
    expense: 'ค่าใช้จ่าย',
  },

  normal_balances: {
    debit: 'เดบิต',
    credit: 'เครดิต',
  },

  statuses: {
    draft: 'ฉบับร่าง',
    posted: 'ผ่านรายการแล้ว',
    voided: 'ยกเลิกแล้ว',
  },

  depreciation_methods: {
    straight_line: 'เส้นตรง',
    declining_balance: 'ยอดคงเหลือลดลง',
  },

  asset_statuses: {
    active: 'ใช้งาน',
    fully_depreciated: 'ค่าเสื่อมราคาครบแล้ว',
    disposed: 'จำหน่ายแล้ว',
  },

  filters: {
    all_types: 'ทุกประเภท',
    all_statuses: 'ทุกสถานะ',
    all_methods: 'ทุกวิธี',
    all_properties: 'ทุกอาคาร',
    property: 'อสังหาริมทรัพย์',
    date_from: 'ตั้งแต่',
    date_to: 'ถึง',
    status: 'สถานะ',
    none: '— ไม่มี —',
    none_root_account: '— ไม่มี (บัญชีระดับบนสุด) —',
  },

  messages: {
    error_loading: 'ไม่สามารถโหลดข้อมูลได้',
    error_description: 'กรุณาลองใหม่อีกครั้ง',
    balanced: 'รายการสมดุล',
    not_balanced: 'รายการไม่สมดุล เดบิตต้องเท่ากับเครดิต',
  },

  setup_guide: {
    title: 'ตั้งค่าระบบบัญชี',
    description: 'กำหนดผังบัญชีเพื่อเริ่มบันทึกธุรกรรมทางการเงินและสร้างงบการเงิน',
    step_1_title: 'สร้างผังบัญชีมาตรฐาน',
    step_1_description: 'สร้างผังบัญชีมาตรฐานของไทยเป็นจุดเริ่มต้น',
    step_2_title: 'สร้างรายการบันทึกบัญชี',
    step_2_description: 'บันทึกธุรกรรมทางการเงินด้วยระบบบัญชีคู่',
    step_3_title: 'สร้างงบการเงิน',
    step_3_description: 'ดูงบกำไรขาดทุน งบดุล และรายงานกระแสเงินสด',
  },
}
